export const applicationConstants = { 
    APPLY_TO_JOB_REQUEST: 'APPLY_TO_JOB_REQUEST',
    APPLY_TO_JOB_SUCCESS: 'APPLY_TO_JOB_SUCCESS',
    APPLY_TO_JOB_FAILURE: 'APPLY_TO_JOB_FAILURE',
    APPLY_RESET: 'APPLY_RESET'
}